export interface ClosedPeriod {
  startTime: string // HH:MM format
  endTime: string // HH:MM format
}

export interface DayHours {
  dayOfWeek: number // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  isOpen: boolean
  startTime: string // HH:MM format
  endTime: string // HH:MM format
  slotDuration: number // in minutes (default: 30)
  closedPeriods?: ClosedPeriod[] // Closed periods during the day (e.g., lunch breaks)
}

export interface ClinicHours {
  id: string
  name: string
  description?: string
  days: DayHours[]
  timezone?: string
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export interface ClinicHoursFormData {
  name: string
  description?: string
  days: DayHours[]
  timezone?: string
  isActive: boolean
}

export const DAYS_OF_WEEK = [
  { value: 0, label: 'Sunday', short: 'Sun' },
  { value: 1, label: 'Monday', short: 'Mon' },
  { value: 2, label: 'Tuesday', short: 'Tue' },
  { value: 3, label: 'Wednesday', short: 'Wed' },
  { value: 4, label: 'Thursday', short: 'Thu' },
  { value: 5, label: 'Friday', short: 'Fri' },
  { value: 6, label: 'Saturday', short: 'Sat' },
] as const



